import moment from 'moment';

export default function (injection, Vue) {
    Vue.filter('date', (unix) => {
        const validator = injection.util.validator();
        if (validator.isEmpty(unix)) {
            return '';
        }
        return moment.unix(unix).format('YYYY-MM-DD');
    });
    Vue.filter('date2m', (unix) => {
        const validator = injection.util.validator();
        if (validator.isEmpty(unix)) {
            return '';
        }
        if (validator.isNumeric(unix)) {
            return unix === 0 ? '-' : moment.unix(unix).format('YYYY-MM-DD HH:mm');
        } else if (typeof unix === 'string') {
            return moment(unix).format('YYYY-MM-DD HH:mm');
        } else {
            return '';
        }
    });
    Vue.filter('date2ms', (unix) => {
        const validator = injection.util.validator();
        if (validator.isEmpty(unix)) {
            return '';
        }
        return moment.unix(unix).format('YYYY-MM-DD HH:mm:ss');
    });
    Vue.filter('sting2m', (str) => {
        return !str ? '' : moment(str).format('YYYY-MM-DD HH:mm');
    });
}
